

import Modal from "react-modal";
import React, {useEffect, useState} from "react";
import './Variz.css'
import axios from "axios";
import {useMediaQuery} from "beautiful-react-hooks";
import Select, {components} from 'react-select';
import SelectAsyncPaginate from "./SelectAsyncPaginate";
import { toast } from "react-toastify";
import { useAuthState } from "../../Context/auth-context";

import ConfirmLevel from "./ConfirmLevel";

import { useNavigate } from "react-router-dom";









export default function ({modalIsOpen,Openchanger,coinSelected='BTC',coinChanger}){

    const [amount,setamount] = useState('')
    const { SingleValue, Option } = components;
    const [userBalance,setUserBalance] = useState([])
    const [processing,setProcessing] = useState(false)


    const isSmall = useMediaQuery('(max-width: 1000px)')
    const [options,setOptions] = useState([])
    const [DepositAddresses,setDepositAddresses] = useState()
    const [loading,setLoading] = useState(false)
    const [coinBalance,setCoinBalance] = useState({})
    const [address,setAddress] = useState('')
    const [memo,setMemo] = useState('')
    const [coins, setCoins] = useState({label:'',value:coinSelected,image:`https://static.sinatether.com/CoinsImg/${coinSelected}.png`});
    const [currentChain, setcurrentChain] = useState(null);
    const {isEhraz} = useAuthState()
    const [loadingButton,setLoadingButton] = useState(false)
    const [checkGoogle,setCheckGoogle] = useState(false)
    const[google,setGoogle] = useState('')


    const navigate = useNavigate()
    
    const [isDialogOpen, setDialogOpen] = useState(false);
  
    const handleOpenDialog = () => {
      setDialogOpen(true);
    };
  
    const handleCloseDialog = () => {
  
      setDialogOpen(false);
    };
  
    const handleConfirmPurchase = () => {
      setDialogOpen(false);
      navigate('/top-authentication')
  
    };






    function toFixed(x) {
        if (Math.abs(x) < 1.0) {
          let e = parseInt(x.toString().split('e-')[1]);
          if (e) {
              x *= Math.pow(10,e-1);
              x = '0.' + (new Array(e)).join('0') + x.toString().substring(2);
          }
        } else {
          let e = parseInt(x.toString().split('+')[1]);
          if (e > 20) {
              e -= 20;
              x /= Math.pow(10,e);
              x += (new Array(e+1)).join('0');
          }
        }
        return x;
      }




      function toFixedTrunc(x, n) {
        x = toFixed(x) 
  
        // From here on the code is the same than the original answer
        const v = (typeof x === 'string' ? x : x.toString()).split('.');
        if (n <= 0) return v[0];
        let f = v[1] || '';
        if (f.length > n) return `${v[0]}.${f.substr(0,n)}`;
        while (f.length < n) f += '0';
        return parseFloat(`${v[0]}.${f}`)
      }


    

    const onchangeSelect = (item) => {
          setcurrentChain(null);
          setCoins(item);
    };


       useEffect(()=>{
            findBalance(coins.value)


       },[coins])



     





       const customStylesDesktop = {
        overlay: {
      position: 'fixed',
                  zIndex: 1020,
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  background: 'rgba(0,0,0, 0.5)',
                  display: 'flex',
                  justifyContent: 'center',


    },

          content: {
           background: '#ffffff',
                  width: '60rem',
                  maxWidth: 'calc(150vw - 2rem)',
                  maxHeight: 'calc(100vh - 2rem)',
                  border:'0px',
                  overflowY: 'auto',
                  position: 'relative',
                  borderRadius: '0.8rem',
              inset: '9px'




          },


};

    const customStylesMobile = {
        overlay: {
      position: 'fixed',
                  zIndex: 1020,
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  background: 'rgba(0,0,0, 0.5)',
                  display: 'flex',
                  justifyContent: 'center',


    },

          content: {
           background: '#FFFFFF',
                  width: '34rem',
                  maxWidth: 'calc(150vw - 2rem)',
                  maxHeight: 'calc(95vh - 1rem)',
                  overflowY: 'auto',
                  border:'0px',
                  position: 'relative',
                  borderRadius: '0.4rem',
                  inset:'0px',
                  margin : '0vh 0px 0px 0px',



          },


};


    useEffect(async ()=>{

        await axios.get('https://api.sinatether.com/Auth/GetCurrencies/',{withCredentials:true}).then((res)=>{
            if(res.status == 200)
            {
                setOptions(res.data['curr'])
                for (let i=0;i<res.data['curr'].length;i++){



                     if (res.data['curr'][i].value == coinSelected ){



                         setCoins(res.data['curr'][i])

                       //  findCoinSelected(options[i].value,coinBy.value)
                         break;
                     }

                 }

                 findBalance(coinSelected)




            }
        })

        await axios.get('https://api.sinatether.com/Auth/check_google').then((res)=>{



           if (res.status == 200){

               setCheckGoogle(res.data['is_auth_google'])
           }

        



        })

    },[])




        function findBalance(inputSym) {

            axios.get('https://api.sinatether.com/Auth/GetBalanceUser/', {
                withCredentials:true
            }).then((res) => {
                if (res.status == 200) {
                    setUserBalance(res.data['userBalance'])
                    setProcessing(true)


                        for (let i = 0; i < res.data['userBalance'].length; i++) {
                            if (res.data['userBalance'][i]['nameCoin'] == inputSym) {
                                setCoinBalance(res.data['userBalance'][i])
                                setProcessing(true)
                                return
                            }
                        }

                    setCoinBalance({'phone':"*********","nameCoin":inputSym,"balance":0,"blocked":0})
                }

            }).catch((error)=>{
                if(error){
                    if (error.response.status === 400){
                        toast.dismiss()
                        toast.error("نشست شما منقضی شده است مجددا وارد شوید")
                    }
                }
            })







        if (userBalance) {

            for (let i = 0; i < userBalance.length; i++) {
                if (userBalance[i]['nameCoin'] == inputSym) {
                    setCoinBalance(userBalance[i])
                    setProcessing(true)
                    return
                }
            }

        }

    }







const IconSingleValue2 = (props) => (
    <SingleValue {...props}>
        <img src={props.data.image} style={{ height: '30px', width: '30px', borderRadius: '50%', marginRight: '10px' }} alt=""/>
        <span className={'text-large pl-1'}>{props.data.label}</span>
    </SingleValue>
);

const IconOption2 = (props) => (
    <Option {...props}>
        <img src={props.data.image} style={{ height: '30px', width: '30px', borderRadius: '50%', marginRight: '10px' }} alt=""/>
        <span className={'text-large pl-1'}>{props.data.label}</span>
    </Option>
);



const customStyles = {

    control: (provided) => ({
        ...provided,
        backgroundColor: '#F0F0F0',
        borderRadius:'12px',
        height:'40px'



  }),

    option: (provided,{isFocused,isSelected}) => ({
        ...provided,
        backgroundColor:'#F0F0F0',
        color:'white',
         background: isFocused
        ? '#e0dfe3'
        : isSelected
            ? '#e0dfe3'
            : undefined,
    zIndex: 1,

    }),
    singleValue: (provided,{isFocused}) => ({
        ...provided,
        backgroundColor:'#F0F0F0',
        borderRadius:'12px',
        borderColor: isFocused ? '#2DBD96' : '#2DBD96'


    }),
}






    Modal.setAppElement('#root');




    let subtitle;
    function afterOpenModal() {
  }
   function closeModal() {
        coinChanger('')
        Openchanger(false)

  }


 




function separateNum(event) {
        let value = event.target.value
        var nStr = value + '';
        nStr = nStr.replace(/\,/g, "");
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        if (event !== undefined) {
            event.target.value = x1 + x2;
            ex_normalNum(event.target.value)
        } else {
            return x1 + x2;
        }
    }



    function ex_normalNum(num) {
            num = num.replace(/,\s?/g, "");
            
            setamount(num);
        }




    function handelSubmit(){


        setLoadingButton(true)
        /*if(!isEhraz){
            toast.dismiss()
            toast.error("عدم داشتن احرازهویت")
            return

        }*/


        if (!amount || !coins || !currentChain  || !address){
            toast.dismiss()
            toast.error('لطفا تمام فیلدها را به درستی وارد نمایید')
            setLoadingButton(false)
            return
        }


        if (amount < Number(DepositAddresses['withdrawMinSize'])){
            toast.dismiss()
            toast.error("مقدار درخواستی کمتر از حداقل مقدار برداشت در شبکه است")
            setLoadingButton(false)

            return


        }



        document.getElementById('address').value = ''
        document.getElementById('memo').value = ''
        document.getElementById('amount').value = ''










        axios.post('https://api.sinatether.com/Auth/GetBardashCoinstRequest/',
            {'amount': amount, 'currency':coins['value'],'chain':currentChain['value'],'memo':memo,'address':address,'oauth':checkGoogle?google : ''},{

         withCredentials:true
        }).then((res)=>{

            if (res.status == 200){
                if(res.data['status'] == 200){
                    toast.dismiss()
                    toast.success(res.data['message'])
                    
                }else {
                    toast.dismiss()
                    if (res.data['state'] == false){
                        setDialogOpen(true)
    
                    }else{
    
                    
                    toast.error(res.data['message'])
                    }

                }
                setAddress('')
                setamount('')
                setMemo('')

                setLoadingButton(false)

            }


        }).catch((error)=>{
            if(error){
                if (error.response.status === 400){
                    toast.dismiss()
                    toast.error("نشست شما منقضی شده است مجددا وارد شوید")

                }else{
                toast.dismiss()

                    toast.error('فرایند به طور کامل انجام نشد مجددا امتحان کنید')
                }


                setLoadingButton(false)

            }
        })
    }






    let num;

   

   
    function HandleChooseBalance() {
        let bal = coinBalance['balance']
        var precision
        try{
        precision = Number(DepositAddresses['precision'])
        }catch(error){
            toast.warning("ابتدا شبکه مد نظر خود را انتخاب کنید")
            return
        }
        bal = toFixedTrunc(bal,precision)

        setamount(bal)

        document.getElementById("amount").value = new Intl.NumberFormat("fa",{maximumFractionDigits:8} ).format(coinBalance['balance'])

     }





    function separateNum(event) {
        let value = event.target.value
        var nStr = value + '';
        nStr = nStr.replace(/\,/g, "");
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        if (event !== undefined) {
            event.target.value = x1 + x2;
            ex_normalNum(event.target.value)
        } else {
            return x1 + x2;
        }
    }



    function ex_normalNum(num) {
            num = num.replace(/,\s?/g, "");
            if(DepositAddresses){
                let precision = Number(DepositAddresses['precision'])
                num = toFixedTrunc(num,precision)



            }
            setamount(num);
        }



     function Gotolist() {
         window.location.replace('/HistBardashtCoins')
     }








  return(
      <>


              
    <ConfirmLevel 
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
        onConfirm={handleConfirmPurchase}
      />

      {isSmall ?
              <Modal
                    isOpen={modalIsOpen}
                    onAfterOpen={afterOpenModal}
                    ariaHideApp={false}
                    style={customStylesMobile}
                    contentLabel="Example Modal"
                    backdrop= "static"

                  >

                      <div className={'container'} id={'mbody'}>
                          <div className={'title'}>
                              <span className="close" onClick={closeModal}>&times;</span>
                              <h5 className="myheav">برداشت ارز</h5>
                              <hr/>


                          </div>

                          <div className={'row'}>

                                  <form className={'col-md-7'}>
                                      {loading ?
                                          <>
                                              <i className="fa fa-spinner fa-spin"></i>
                                          </>


                                          :
                                          <>


                                              <label className={'text-large'}>انتخاب ارز:</label>
                                           <Select
                                                  value={coins}
                                                  onChange={onchangeSelect}
                                                  options={options}
                                                  getOptionValue={(option) => option.value}
                                                  getOptionLabel={(option) => option.label}
                                                  styles={customStyles}

                                                  components={{
                                                      SingleValue: IconSingleValue2,
                                                      Option: IconOption2
                                                  }}
                                                  />
                                              <label className={'text-large pt-2'}>انتخاب شبکه پرداخت:</label>
                                               <SelectAsyncPaginate
                                                   styles={customStyles}
                                                 coinName={coins['value']}
                                                 value={currentChain}
                                                 onChange={(coin) => setcurrentChain(coin)}
                                                   getDeposit={setDepositAddresses}
                                                   type = {"withdraw"}
                                                />
                                      {DepositAddresses ? 
                                                <div className="row pt-1 text-medium text-bold text-muted">
                                                    <div className="col-6 pr-0 pl-0">

                                                    <span className="text-right pr-2">
                                                        حداقل مقدار برداشت :

                                                    </span>
                                                    <span className="text-right">
                                                        {DepositAddresses['withdrawMinSize']}
                                                        <span>{DepositAddresses['currency']}</span>

                                                    </span>
                                                    </div>

                                                    <div className="col-6 pl-0 pr-0">
                                                   <span className="text-right pr-2">
                                                        حداقل مقدار کارمزد شبکه :

                                                    </span>
                                                    <span className="text-right">
                                                      {DepositAddresses['withdrawMinFee']}
                                                      <span>{DepositAddresses['currency']}</span>


                                                    </span>
                                                   </div>

                                                </div>

                                                :
                                                <></>
                                      }


                                                  <div className={'w-100'}>
                                                      <div className={'w-100 text-white'}>
                                                      <label className={'text-large pt-2'}>مبلغ برداشت:</label>
                                                          <input
                                                              className={'myinput_form text-center w-100 text-large bg-custom-input myinput_form w-100  border bg-custom-input input-order667 input-order667 magg6'} id={'amount'} type={'tel'}  onKeyUp={separateNum}
                                                               />

                                                               <div className={DepositAddresses?'cssdsfstrrfgrh' : 'kdsjgfhsgyrh'}>
                                                               <button onClick={HandleChooseBalance} type={'button'}
                                                                className={'btn btn-primary btn-sor btnes244 '}>کل
                                                                موجودی

                                                            </button>
                                                               </div>


                                                      </div>
                                                      <div className={'pt-2 pb-2'}>

                                                      <span className={'text-medium mytext-warning '}>موجودی قابل برداشت شما:
                                                              <span className={'text-large pr-2 mytext-warning'}>{coinBalance['balance']}</span>
                                      

                                                          </span>
                                                      </div>

                                                          <>


                                                              <div className={'w-100  text-white'}>
                                                                  <label className={'text-large'}>آدرس کیف پول شما:</label>


                                                                  <div className={'text-center'}>


                                                                      <input
                                                                          className={'myinput_form text-center w-100 text-large bg-custom-input myinput_form w-100  border bg-custom-input input-order667 input-order667 magg6  '} id={'address'} value={address} onChange={e=>setAddress(e.target.value)}
                                                                           />
                                                                  </div>


                                                              </div>
                                                              <div>

                                                              <label className={'text-large pt-2'}>تگ(memo)کیف پول مقصد: (در صورتی که از  کیف پول مقصد  ممو دریافت نکرده اید خالی بگذارید)</label>
                                                          <input
                                                              className={'myinput_form text-center w-100 text-large bg-custom-input myinput_form w-100  border bg-custom-input input-order667 input-order667 magg6'} id={'memo'} dir={'ltr'} value={memo} onChange={e=>setMemo(e.target.value)}
                                                               />

                                                              </div>

                                                              {checkGoogle?

                                                              <div className={'w-100  text-white'}>
                                                                  <label className={'text-large'}>کد تایید دو مرحله ای</label>


                                                                  <div className={'text-center'}>


                                                                      <input
                                                                          className={'myinput_form text-center w-100 text-large bg-custom-input myinput_form w-100  border bg-custom-input input-order667 input-order667 magg6  '} id={'google_code'} value={google} onChange={e=>setGoogle(e.target.value)}
                                                                           />
                                                                  </div>


                                                              </div>

                                                              :

                                                              <></>
                                                            }




                                                          </>





                                                  </div>
                                          </>


                                      }


                                      
                         <div className={'text-left btnvariz '}>

                                    <button type={"button"} className={'btn  btn-success py-2 btsubmit2020 lfjdifhdfj6626 '} data-inline={true} onClick={handelSubmit}>
                                        
                                    {loadingButton ? 
                                            <i className="fa fa-spinner fa-spin text-white"></i>

                                            :



                                            <>
                                            ثبت برداشت
                                            </>

                                        }                                 
                                        
                                        </button>

                                    </div>



                                  </form>

                              <form className={'col-md-5  mt-2'}>


                              <div className={'lfjdifhdfj6626 '}>
                            <div className={'title_warning fhyfgeyrberh200'}>
                              

                                <div className={' mt-2 pl-1'}>

                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>
                                    <span>لطفا در وارد کردن آدرس و تگ کیف پول خود دقت فرمایید.در صورت خطا ارز شما قابل بازگردانی نیست.</span>
                            

                                    </span>

                                </div>
                                <div className={'mt-2 pl-1'}>
                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>

                                    <span>   زمان لازم برای انجام تراکنش هر رمز ارز بر اساس شبکه انتخابی شما و شلوغی آن، متغیر است</span>
                                                                        </span>

                                </div>



                                 <div className={'mt-2 pl-1 pb-2'}>
                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>

                                    <span>در صورت ثبت آدرس اعتباری حتما  پشتیبانی را در جریان قرار دهید.</span>


                                    </span>

                                </div>
                            </div>
                            <div>

                            </div>

                        </div>

                                    


                                      <div className="card-tazakor">

<div>
   <div className="tewxtushe63">توجه !</div>

   کاربر گرامی لطفا در نظر داشته باشید هرگونه خطا در ثبت آدرس و تگ (memo) منجر به از بین رفتن دارایی شما میشود.
درصورت خطا در ثبت اطلاعات آدرس مقصد، دارایی شما قابل بازگردانی نخواهد بود و سیناتـتر مسئولیتی را در این موارد بر عهده نخواهد داشت.
             </div>

</div>

                                

                              </form>

                          </div>



                      </div>




                  </Modal>

              :
                  <Modal
                    isOpen={modalIsOpen}
                    onAfterOpen={afterOpenModal}
                    ariaHideApp={false}
                    style={customStylesDesktop}
                    contentLabel="Example Modal"
                    backdrop= "static"

                  >

                      <div className={'container'} id={'mbody'}>
                          <div className={'title'}>
                              <span className="close" onClick={closeModal}>&times;</span>
                            


                          </div>

                          <div className={'row'}>

                                  <form className={'col-md-7 h-100 card820820  jeiurguyegu66'}>
                                  <div className="titledesl820">برداشت ارز </div>

                                      {loading ?
                                          <>
                                              <i className="fa fa-spinner fa-spin"></i>
                                          </>


                                          :
                                          <>


                                              <label className={'text-large'}>انتخاب ارز:</label>
                                           <Select
                                                  value={coins}
                                                  onChange={onchangeSelect}
                                                  options={options}
                                                  getOptionValue={(option) => option.value}
                                                  getOptionLabel={(option) => option.label}
                                                  styles={customStyles}

                                                  components={{
                                                      SingleValue: IconSingleValue2,
                                                      Option: IconOption2
                                                  }}
                                                  />
                                              <label className={'text-large pt-2'}>انتخاب شبکه پرداخت:</label>
                                               <SelectAsyncPaginate
                                                   styles={customStyles}
                                                 coinName={coins['value']}
                                                 value={currentChain}
                                                 onChange={(coin) => setcurrentChain(coin)}
                                                   getDeposit={setDepositAddresses}
                                                   type = {"withdraw"}

                                                />
                                                {DepositAddresses ? 
                                                <div className="row pt-1 text-medium text-bold text-muted">

                                                    <div className="col-6">

                                                    <span className="text-right pr-2">
                                                        حداقل مقدار برداشت :

                                                    </span>
                                                    <span className="text-right">
                                                        {DepositAddresses['withdrawMinSize']}
                                                        <span>{DepositAddresses['currency']}</span>

                                                    </span>

                                                </div>
                                                   <div className="col-6">
                                                   <span className="text-right pr-2">
                                                        حداقل مقدار کارمزد شبکه :

                                                    </span>
                                                    <span className="text-right ">
                                                      {DepositAddresses['withdrawMinFee']}
                                                      <span>{DepositAddresses['currency']}</span>


                                                    </span>
                                                   </div>
                                                </div>


                                                :
                                                <></>
                                      }


                                              <br/>
                                                  <div className={'w-100'}>
                                                      <div className={'w-100 '}>
                                                        <div className="d-flex">
                                                        <label className={'text-large pt-2'}>مبلغ برداشت:</label>
                                                      <div className={'ksdjshrtetetppa'}>

<span className={'text-medium mytext-warning '}>موجودی قابل برداشت شما:
        <span className={'text-large pr-2 mytext-warning'}>{coinBalance['balance'] && new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(coinBalance['balance'])}</span>


    </span>
</div>
       

                                                        </div>
                                                   <input
                                                              className={'myinput_form text-center w-100 text-large bg-custom-input myinput_form w-100  border bg-custom-input input-order667 input-order667 magg6'} id={'amount'} type={'tel'}  onKeyUp={separateNum}
                                                               />
                                                                 <div className={DepositAddresses?'cssdsfstrrfgrh' : 'kdsjgfhsgyrh'}>
                                                               <button onClick={HandleChooseBalance} type={'button'}
                                                                className={'btn btn-primary btn-sor btnes244 '}>کل
                                                                موجودی

                                                            </button>
                                                               </div>


                                                      </div>
                         

                                                          <>


                                                              <div className={'w-100  text-white'}>
                                                                  <label className={'text-large pt-2'}>آدرس کیف پول شما:</label>


                                                                  <div className={'text-center'}>


                                                                      <input
                                                                          className={'myinput_form text-center w-100 text-large bg-custom-input  myinput_form w-100  border bg-custom-input input-order667 input-order667 magg6 '} id={'address'} value={address} onChange={e=>setAddress(e.target.value)}
                                                                           />
                                                                  </div>


                                                              </div>
                                                              <div>

                                                              <label className={'text-large pt-2'}>تگ(memo)کیف پول مقصد: (در صورتی که از  کیف پول مقصد  ممو دریافت نکرده اید خالی بگذارید)</label>
                                                          <input
                                                              className={'myinput_form text-center w-100 text-large bg-custom-input myinput_form w-100  border bg-custom-input input-order667 input-order667 magg6'} id={'memo'} dir={'ltr'} value={memo} onChange={e=>setMemo(e.target.value)}
                                                               />

                                                              </div>

                                                            {checkGoogle?

                                                              <div className={'w-100  text-white'}>
                                                                  <label className={'text-large pt-3'}>کد تایید دو مرحله ای </label>


                                                                  <div className={'text-center'}>


                                                                      <input
                                                                          className={'myinput_form text-center w-100 text-large bg-custom-input  myinput_form w-100  border bg-custom-input input-order667 input-order667 magg6 '} id={'google_check'} value={google} onChange={e=>setGoogle(e.target.value)}
                                                                           />
                                                                  </div>


                                                              </div>
                                                              :

                                                              <></>
                                                            }

                                                          </>





                                                  </div>
                                          </>

                                          


                                      }

                <div className={'text-left btnvariz '}>
                    <br/>

                             <button type={"button"} className={'btn  btn-success py-2 btsubmit2020'} data-inline={true} onClick={handelSubmit}>
                                 {loadingButton ? 
                                     <i className="fa fa-spinner fa-spin text-white"></i>

                                     :



                                     <>
                                     ثبت برداشت
                                     </>

                                 }


                                     



      
                                 
                                 
                                 
                                 </button>

                         </div>



                                  </form>

                              <form className={'col-5'}>
                              <div className={'lfjdifhdfj6626 '}>
                            <div className={'title_warning fhyfgeyrberh200'}>
                              

                                <div className={' mt-2 pl-1'}>

                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>
                                    <span>لطفا در وارد کردن آدرس و تگ کیف پول خود دقت فرمایید.در صورت خطا ارز شما قابل بازگردانی نیست.</span>
                            

                                    </span>

                                </div>
                                <div className={'mt-2 pl-1'}>
                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>

                                    <span>   زمان لازم برای انجام تراکنش هر رمز ارز بر اساس شبکه انتخابی شما و شلوغی آن، متغیر است</span>
                                                                        </span>

                                </div>



                                 <div className={'mt-2 pl-1 pb-2'}>
                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>

                                    <span>در صورت ثبت آدرس اعتباری حتما  پشتیبانی را در جریان قرار دهید.</span>


                                    </span>

                                </div>
                            </div>
                            <div>

                            </div>

                        </div>


                        
                        <div className="card-tazakor ">

<div>
   <div className="tewxtushe63">توجه !</div>

   کاربر گرامی لطفا در نظر داشته باشید هرگونه خطا در ثبت آدرس و تگ (memo) منجر به از بین رفتن دارایی شما میشود.
درصورت خطا در ثبت اطلاعات آدرس مقصد، دارایی شما قابل بازگردانی نخواهد بود و سیناتـتر مسئولیتی را در این موارد بر عهده نخواهد داشت.
             </div>

</div>
                              </form>

                          </div>


                         

                      </div>




                  </Modal>
      }
            </>


  )
}